import { loadUsers } from "../common/api";

const model = {
    name: 'admin',
    state: { 
        loaded: false,
        currentId: '',
        byId: {}
    },
    reducers: {
        setCurrentId: ( state, payload ) => {
            return {
                ...state,
                currentId: payload.email
            }
        },
        cdcInsert: ( state, payload ) => {
            return {
                ...state,
                byId: {
                    ...state.byId,
                    [payload.email]: { ...payload.cdc }
                }
            }
        },
        cdcModify: ( state, payload ) => {
            return {
                ...state,
                byId: {
                    ...state.byId,
                    [payload.email]: {
                        ...state.byId[payload.email],
                        ...payload.cdc
                    }
                }
            }
        },
        cdcRemove: ( state, payload ) => {
            const keys = Object.keys( state.byId ).filter( f => f !== payload.email );
            let newObj = {};
            keys.forEach( k => newObj[k] = state.byId[k] );
            return {
                ...state,
                byId: newObj
            }
        },
        loadedUsers: ( state, payload ) => {
            return {
                ...state,
                byId: {
                    ...state.byId,
                    ...payload.id
                },
                loaded: true
            }
        }
    },
    effects: ( dispatch ) => ( {
        async loadUsers( { orgId, aid, uid, segment } ) {
            const list = await loadUsers( orgId, aid, uid, segment );
            const byId = {};
            list.forEach( u => {
                byId[u.email] = u;
            } );
            dispatch.admin.loadedUsers( { id: byId } );
        },
        insert( { email, cdc } ) {
            dispatch.admin.cdcInsert( { email, cdc } );
        },
        modify( { email, cdc } ) {
            dispatch.admin.cdcModify( { email, cdc } );
        },
        remove( { email } ) {
            dispatch.admin.cdcRemove( { email } );
        },
        setCurrent( { email } ) {
            dispatch.admin.setCurrentId( { email } );
        }
    } )
}

export default model;